import React, { PureComponent } from 'react';
import { Popover } from 'antd';

interface MainFlowGraphProps {
    heightEm: number;
    values: Array<number>;
}

export class MainFlowGraph extends PureComponent<MainFlowGraphProps> {
    render() {
        return (
            <svg className="main-flow" height={this.props.heightEm + 'em'} style={{ width: '100%' }}>
                {/* Y axis + bars */}
                <g>
                    <svg x="0" y="0%" height="80%" width="100%">
                        <linearGradient id="gradient" x2="1" y2="1">
                            <stop offset="0%" stopColor="#0D2C40" />
                            <stop offset="100%" stopColor="#181A1B" />
                        </linearGradient>

                        {/* background gradient */}
                        <rect x="0" y="50%" width="100%" height="50%" fill="url(#gradient)" />

                        {/* scale lines (every 20%) */}
                        <rect x="0" y={100 / 6 + '%'} width="100%" height={'1px'} fill="#000000" />
                        <rect x="0" y={200 / 6 + '%'} width="100%" height={'1px'} fill="#000000" />
                        <rect x="0" y={300 / 6 + '%'} width="100%" height={'1px'} fill="#000000" />
                        <rect x="0" y={400 / 6 + '%'} width="100%" height={'1px'} fill="#000000" />
                        <rect x="0" y={500 / 6 + '%'} width="100%" height={'1px'} fill="#000000" />
                        <rect x="0" y={600 / 6 + '%'} width="100%" height={'1px'} fill="#000000" />

                        {/* scale text (60% & 100%) */}
                        <text x="0" y={100 / 6 - 2 + '%'} fontSize={this.props.heightEm / 8 + 'em'} fontWeight="bold">
                            100
                        </text>
                        <text x="0" y={300 / 6 - 2 + '%'} fontSize={this.props.heightEm / 8 + 'em'} fontWeight="bold">
                            60
                        </text>

                        {/* bars */}
                        <g>
                            <svg x="0" y={100 / 6 + '%'} height={500 / 6 + '%'} width="100%">
                                {this.props.values.map((value, idx) => {
                                    return (
                                        <g key={'bar-' + idx} className="bar">
                                            <svg x={4 * (idx + 1) + '%'} y="0" height="100%" width="4%">
                                                {/* First rectangle with transparent background, so that parent <g> has a width that corresponds to the full width available for a bar */}
                                                {/* This allows to have a smooth transition when mouse goes over each bar */}
                                                <rect x="0" y="0" width="100%" height="100%" fill="transparent" />
                                                {/* Second rectangle that corresponds to the bar itself, centered horizontally with a width of 3%, to leave 0.5% margin on the left and right */}
                                                <rect
                                                    className={`${value >= 0.6 ? 'overload' : ''}`}
                                                    x="12.5%"
                                                    y={(1 - value) * 100 + '%'}
                                                    width="75%"
                                                    height={value * 100 + '%'}
                                                    rx="0.25em"
                                                />
                                                {/* Foreign object used to inject the Popover component inside */}
                                                <foreignObject
                                                    width="100%"
                                                    height="100%"
                                                    style={{ position: 'relative' }}>
                                                    <Popover content={<BarPopover criticalProbability={value} />}>
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                width: '100%',
                                                                height: value * 100 + '%',
                                                                top: (1 - value) * 100 + '%',
                                                            }}>
                                                            &nbsp;
                                                        </div>
                                                    </Popover>
                                                </foreignObject>
                                            </svg>
                                        </g>
                                    );
                                })}
                            </svg>
                        </g>
                    </svg>
                </g>
                {/* X-axis*/}
                <g>
                    <svg x="0" y="80%" height="20%" width="100%">
                        {this.props.values.map((value, idx) => {
                            const hour = idx + 1;
                            if (hour % 3 === 0)
                                return (
                                    <text
                                        key={'x-axis-label-' + hour}
                                        x={4 * hour + 2 + '%'}
                                        y="100%"
                                        fontSize={this.props.heightEm / 8 + 'em'}
                                        fill="#8C8B82"
                                        fontWeight="bold"
                                        textAnchor="middle">
                                        <tspan>
                                            {hour === 24 ? '0' : hour}
                                            <tspan fontSize="0.75em">h</tspan>
                                        </tspan>
                                    </text>
                                );
                            else return undefined;
                        })}
                    </svg>
                </g>
            </svg>
        );
    }
}

interface BarPopoverProps {
    criticalProbability: number;
}

class BarPopover extends PureComponent<BarPopoverProps> {
    render() {
        const color = this.props.criticalProbability >= 0.6 ? '#DBAD48' : '#4CA3CA';
        return (
            <div>
                <span style={{ fontSize: '1.1em', fontWeight: 'bold', color: color }}>
                    {(this.props.criticalProbability * 100).toFixed(0) + '%'}
                </span>{' '}
                critical probablility
            </div>
        );
    }
}
